import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-disc-grp-cust-langs',
  templateUrl: './disc-grp-cust-langs.component.html',
  styleUrls: ['./disc-grp-cust-langs.component.css']
})
export class DiscGrpCustLangsComponent implements OnInit {
    discGrpCustKeyno;

    public inputListLanguages: InputLanguageItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.discGrpCustKeyno = this.stateService.getStateParams()['discgrpcust_keyno'];
    }

    private async loadLanguages(): Promise<void> {
        this.inputListLanguages = await this.datatask.Post(3121, { discgrpcust_keyno: this.discGrpCustKeyno });
    }

    public async saveChanges() {
        if (!!this.inputListLanguages) {
            try {
                this.saving = true;

                await this.datatask.Post(3122, { records: this.inputListLanguages });

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadLanguages();
    }

    ngOnInit() {
        this.init();
    }
}

interface InputLanguageItem {
    discgrpcust_keyno: number;
    discgrpcust_name: string;
    language_id: string;
    language_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('discGrpCustLangs', {
//        templateUrl: 'views/components/views/discGrpCustLangs/discGrpCustLangs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'discGrpCustLangsService', function ($stateParams, stateService, discGrpCustLangsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let discGrpCustKeyno = $stateParams.discgrpcust_keyno;

//            vm.model = {
//                inputListLanguages: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadLanguages() {
//                vm.model.inputListLanguages = await discGrpCustLangsService.listLanguages({ discgrpcust_keyno: discGrpCustKeyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                discGrpCustLangsService.saveObj({ records: vm.model.inputListLanguages }).then(function () {
//                    stateService.back();
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadLanguages();
//            }

//            // #endregion ON INIT FUNCTION
//        }]
//    });
//})();
